import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { GenericResponse, IUserData, IUserNew } from '@interfaces';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ChannelsResponse, EditUser, LevelsUsers, ReassignUser } from '../models/user-management-model';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  private loaderLevelsUsers = new BehaviorSubject<number>(0);
  public resetFormUserPt = new Subject<boolean>();

  constructor(private http: HttpClient, private config: ConfigService) { }

  public getLoaderLevelsUsers(): BehaviorSubject<number> {
    return this.loaderLevelsUsers;
  }

  public setLoaderLevelsUsers(plus: boolean): void {
    let activesCalls = this.loaderLevelsUsers.value;
    plus ? activesCalls++ : activesCalls--;
    this.loaderLevelsUsers.next(activesCalls);
  }

  public resetLoaderLevelsUsers(): void {
    this.loaderLevelsUsers.next(0);
  }

  public setUser(body: IUserNew): Observable<any> {
    return this.http.post<GenericResponse>(this.config.getUrl('user.setUser'), body);
  }

  public getUserManagers(params: any, userRole: string): Observable<any> {
    return this.http.get<GenericResponse<IUserData[]>>(this.config.getUrl('user.getUserManagers', { userRole }), { params });
  }

  public getChannels(): Observable<GenericResponse<ChannelsResponse[]>> {
    return this.http.get<GenericResponse<ChannelsResponse[]>>(this.config.getUrl('user.getChannels'));
  }

  public getLevelsUsers(channel: string): Observable<GenericResponse<LevelsUsers>> {
    return this.http.get<GenericResponse<LevelsUsers>>(this.config.getUrl('user.getLevelsUsers', { codConsultora: channel }));
  }

  public putReassingUser(body: ReassignUser): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('user.putReassign'), body);
  }

  public putEditUser(body: EditUser): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('user.setUser'), body);
  }

  public deleteUser(codUsuario: string): Observable<GenericResponse> {
    return this.http.delete<GenericResponse>(this.config.getUrl('user.deleteUser', { codUsuario }));
  }

  public getManagersPortugal(params: { filter: string }): Observable<any> {
    return this.http.get<GenericResponse<IUserData[]>>(this.config.getUrl('user.getManagers'), { params });
  }

  public getCommercialsPortugal(params: any): Observable<any> {
    return this.http.get<GenericResponse<IUserData[]>>(this.config.getUrl('user.getCommercials'), { params });
  }

  public lastAccess(): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(this.config.getUrl('user.lastAccess'), {});
  }

  public deleteFactors(): Observable<GenericResponse> {
    return this.http.delete<GenericResponse>(this.config.getUrl('user.deleteFactors'));
  }
}
